// Temporary redirect for emails and bookmarks created before the tax-binder rename.
// All /binders/* paths redirect to /tax-binders/* preserving the full path tail.
// Remove approximately 6 weeks after release (around 2026-06-15).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/binders/$')({
  beforeLoad: ({ params }) => {
    const tail = (params as Record<string, string>)['_splat'] ?? '';
    throw redirect({
      href: `/tax-binders/${tail}`,
      replace: true,
    });
  },
  component: () => null,
});
